module.exports = "/_next/static/images/CompleteDataCollectedMobile-0f5704dffa20a73ea8cd8c86ed231b6a.webp";